import React from 'react';
import { Button } from '../_atoms';
import '../styles/spinner.scss';

export const LoaderSpinner = ({
  showLoader,
  showAnswer,
  extra,
  extraItem,
  closeLoader,
  showLineLoader,
  loader,
  className,
}) =>
  showLoader ? (
    <div className={`showLoader ${className}`}>
      {showAnswer ? (
        <div className="answerFromServer">
          <h3>{showAnswer}</h3>
          {!!extra && <p>{extra}</p>}
          {extraItem || <Button onClick={closeLoader}>OK</Button>}
        </div>
      ) : showLineLoader ? (
        <div className="lineLoaderWrapp">
          <h3>Загрузка фотографий</h3>
          <div className="lineLoader">
            <div style={{ width: `${loader}%` }} />
          </div>
        </div>
      ) : (
        <div className="spinner">
          <span className="spinnerTxt">Загрузка</span>
          <div className="lds-spinner">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
    </div>
  ) : null;
